module.exports = __webpack_public_path__ + "static/media/georgia.ca8446d5.ttf";